import React from "react";

/* A choice that is on or off: a channel, a stage, a question, a person to check. Ink while on,
   a white rounded rect with a ring while off. */
export function ToggleChip({ on, onClick, children }: { on: boolean; onClick: () => void; children: React.ReactNode }) {
  return (
    <button
      type="button"
      aria-pressed={on}
      onClick={onClick}
      className={`press h-7 px-2.5 rounded-[8px] text-[12px] font-medium whitespace-nowrap ${
        on
          ? "bg-[var(--text-primary)] text-[var(--surface)]"
          : "bg-[var(--surface)] text-[var(--text-secondary)] ring-1 ring-[var(--hairline-strong)] hover:text-[var(--text-primary)]"
      }`}
    >
      {children}
    </button>
  );
}
